import React from 'react';
import DropdownItem from '@/components/DropdownItem';

const UserRoleTool = ({ onClick, divider }) => (
  <DropdownItem divider={divider} icon="drivers license" textId="actions.role.reassign.verbose" onClick={onClick} />
);

export default UserRoleTool;
